module.exports = __webpack_public_path__ + "static/media/Logo.30d84f26.svg";